import { unByKey } from "ol/Observable";
import type Map from "ol/Map";
import type { EventsKey } from "ol/events";

type HitLog = {
	layerName?: string;
	layerId?: string;
	geom?: string;
	fid?: string | number;
	isCluster?: boolean;
	clusterSize?: number;
};

export const AttachOlEventTrace = (map: Map) => {
	const viewport = map.getViewport();

	const log = (tag: string, payload: any) => {
		// 보기 편하게 한 줄로 찍고 싶으면 JSON.stringify로 줄이세요.
		console.log(`[OL_TRACE][${tag}]`, payload);
	};

	const pickAtPixel = (pixel: [number, number]) => {
		const hits: HitLog[] = [];

		map.forEachFeatureAtPixel(
			pixel,
			(feature, layer) => {
				const fid = feature.getId?.() as any;
				const geom = feature.getGeometry?.()?.getType?.();

				const layerName = (layer as any)?.get?.("name");
				const layerId = (layer as any)?.get?.("id") ?? (layer as any)?.get?.("layerId");

				const clustered = (feature as any).get?.("features");
				const isCluster = Array.isArray(clustered);
				const clusterSize = isCluster ? clustered.length : undefined;

				hits.push({ layerName, layerId, geom, fid, isCluster, clusterSize });
			},
			{
				// 모바일/트랙패드까지 고려하면 10~20이 체감이 좋습니다.
				hitTolerance: 15,
			}
		);

		return hits;
	};

	// 1) DOM 레벨 이벤트(브라우저가 실제 받는 이벤트)
	const domTypes = [
		"pointerdown",
		"pointerup",
		"pointermove",
		"touchstart",
		"touchend",
		"mousedown",
		"mouseup",
		"click",
	] as const;

	const domHandlers = domTypes.map((type) => {
		const handler = (ev: Event) => {
			const e = ev as any;

			log("DOM", {
				ev: type,
				defaultPrevented: ev.defaultPrevented,
				target: e?.target?.className ?? e?.target?.tagName,
				pointerType: e?.pointerType,
				button: e?.button,
				touches: e?.touches?.length,
			});
		};

		// passive false로 해야 preventDefault 여부도 관찰/제어하기 쉬움
		viewport.addEventListener(type, handler as any, { passive: false });
		return { type, handler };
	});

	// 2) OL 레벨 이벤트(MapBrowserEvent)
	const olKeys: EventsKey[] = [];
	(["pointerdown", "pointerup", "singleclick", "click", "moveend"] as const).forEach((type) => {
		const key = map.on(type as any, (evt: any) => {
			const pixel = evt?.pixel as [number, number] | undefined;
			const hits = pixel ? pickAtPixel(pixel) : [];

			console.log(`[OL_TRACE][OL] ev=${type}`, {
				pixel,
				coord: evt?.coordinate,
				dragging: evt?.dragging,
				originalType: evt?.originalEvent?.type,
				hits,
			});
		});
		olKeys.push(key as any);
	});


	// cleanup
	return () => {
		domHandlers.forEach(({ type, handler }) =>
			viewport.removeEventListener(type, handler as any)
		);
		unByKey(olKeys);
	};
};
